<hlm-toaster
  position="top-right"
  richColors
  closeButton
  [visibleToasts]="5"
  class="max-[600px]:[--mobile-offset:0px]!"
  [toastOptions]="toastOptions"
/>

<router-outlet></router-outlet>
